import React from "react";
import { USER_LOGIN_RESET , USER_LOGIN_REQUEST , USER_LOGIN_SUCCESS , USER_LOGIN_FAIL , 
    USER_REGISTRATION_RESET , USER_REGISTRATION_REQUEST , USER_REGISTRATION_SUCCESS , USER_REGISTRATION_FAIL ,
     USER_FORGOT_PASSWORD_RESET , USER_FORGOT_PASSWORD_REQUEST , USER_FORGOT_PASSWORD_SUCCESS , USER_FORGOT_PASSWORD_FAIL ,
     USER_RESET_PASSWORD_RESET , USER_RESET_PASSWORD_REQUEST ,USER_RESET_PASSWORD_SUCCESS , USER_RESET_PASSWORD_FAIL ,
     UPDATE_PROFILE_RESET , UPDATE_PROFILE_REQUEST , UPDATE_PROFILE_SUCCESS ,UPDATE_PROFILE_FAIL ,
     CHANGE_PASSWORD_RESET , CHANGE_PASSWORD_REQUEST ,CHANGE_PASSWORD_SUCCESS ,CHANGE_PASSWORD_FAIL ,
     USER_SETTING_RESET , USER_SETTING_REQUEST , USER_SETTING_SUCCESS ,USER_SETTING_FAIL ,
    USER_GET_PROFILE_RESET , USER_GET_PROFILE_REQUEST , USER_GET_PROFILE_SUCCESS , USER_GET_PROFILE_FAIL,
    GET_ORDERS_RESET ,GET_ORDERS_REQUEST ,GET_ORDERS_SUCCESS,GET_ORDERS_FAIL ,
    GET_ITEMS_RESET , GET_ITEMS_REQUEST , GET_ITEMS_SUCCESS , GET_ITEMS_FAIL,
    ORDER_DETAIL_RESET , ORDER_DETAIL_REQUEST , ORDER_DETAIL_SUCCESS , ORDER_DETAIL_FAIL } from "../../constants/UserConstants";

const initialDefaultState = {
    loading: false,
    status: false,
    data: null,
    error: null,
};


export const LoginReducer = (state = initialDefaultState, action: any) => {
    switch (action.type) {
        case USER_LOGIN_RESET:
            return {
                ...initialDefaultState,
            }
        case USER_LOGIN_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case USER_LOGIN_SUCCESS:
            return {
                ...state,
                loading: false,
                status: true,
                data: action.payload
            }
        case USER_LOGIN_FAIL:
            return {
                ...state,
                loading: false,
                status: false,
                error: action.payload
            }
        default:
            return state;
    }
};


export const RegistrationReducer = (state = initialDefaultState, action: any) => {
    switch (action.type) {
        case USER_REGISTRATION_RESET:
            return {
                ...initialDefaultState,
            }
        case USER_REGISTRATION_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case USER_REGISTRATION_SUCCESS:
            return {
                ...state,
                loading: false,
                status: true,
                data: action.payload
            }
        case USER_REGISTRATION_FAIL:
            return {
                ...state,
                loading: false,
                status: false,
                error: action.payload
            }
        default:
            return state;
    }
};



export const ForgotPasswordReducer = (state = initialDefaultState, action: any) => {
    switch (action.type) {
        case USER_FORGOT_PASSWORD_RESET:
            return {
                ...initialDefaultState,
            }
        case USER_FORGOT_PASSWORD_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case USER_FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                status: true,
                data: action.payload
            }
        case USER_FORGOT_PASSWORD_FAIL:
            return {
                ...state,
                loading: false,
                status: false,
                error: action.payload
            }
        default:
            return state;
    }
};



export const ResetPasswordReducer = (state = initialDefaultState, action: any) => {
    switch (action.type) {
        case USER_RESET_PASSWORD_RESET:
            return {
                ...initialDefaultState,
            }
        case USER_RESET_PASSWORD_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case USER_RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                status: true,
                data: action.payload
            }
        case USER_RESET_PASSWORD_FAIL:
            return {
                ...state,
                loading: false,
                status: false,
                error: action.payload
            }
        default:
            return state;
    }
};


export const UpdateProfileReducer = (state = initialDefaultState, action: any) => {
    switch (action.type) {
        case UPDATE_PROFILE_RESET:
            return {
                ...initialDefaultState,
            }
        case UPDATE_PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case UPDATE_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: true,
                data: action.payload
            }
        case UPDATE_PROFILE_FAIL:
            return {
                ...state,
                loading: false,
                status: false,
                error: action.payload
            }
        default:
            return state;
    }
};

const initialChangePasswordState = {
    loading_password: false,
    status_password: false,
    data_password: null,
    error_password: null,
}; 

export const ChangePasswordReducer = (state = initialChangePasswordState, action: any) => {
    switch (action.type) {
        case CHANGE_PASSWORD_RESET:
            return {
                ...initialChangePasswordState,
            }
        case CHANGE_PASSWORD_REQUEST:
            return {
                ...state,
                loading_password: true,
            }
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                loading_password: false,
                status_password: true,
                data_password: action.payload
            }
        case CHANGE_PASSWORD_FAIL:
            return {
                ...state,
                loading_password: false,
                status_password: false,
                error_password: action.payload
            }
        default:
            return state;
    }
};

export const SettingReducer = (state = initialDefaultState, action: any) => {
    switch (action.type) {
        case USER_SETTING_RESET:
            return {
                ...initialDefaultState,
            }
        case USER_SETTING_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case USER_SETTING_SUCCESS:
            return {
                ...state,
                loading: false,
                status: true,
                data: action.payload
            }
        case USER_SETTING_FAIL:
            return {
                ...state,
                loading: false,
                status: false,
                error: action.payload
            }
        default:
            return state;
    }
};

export const GetProfileReducer = (state = initialDefaultState, action: any) => {
    switch (action.type) {
        case USER_GET_PROFILE_RESET:
            return {
                ...initialDefaultState,
            }
        case USER_GET_PROFILE_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case USER_GET_PROFILE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: true,
                data: action.payload
            }
        case USER_GET_PROFILE_FAIL:
            return {
                ...state,
                loading: false,
                status: false,
                error: action.payload
            }
        default:
            return state;
    }
};

export const GetOrdersReducer = (state = initialDefaultState, action: any) => {
    switch (action.type) {
        case GET_ORDERS_RESET:
            return {
                ...initialDefaultState,
            }
        case GET_ORDERS_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case GET_ORDERS_SUCCESS:
            return {
                ...state,
                loading: false,
                status: true,
                data: action.payload
            }
        case GET_ORDERS_FAIL:
            return {
                ...state,
                loading: false,
                status: false,
                error: action.payload
            }
        default:
            return state;
    }
};

export const OrderDetailReducer = (state = initialDefaultState, action: any) => {
    switch (action.type) {
        case ORDER_DETAIL_RESET:
            return {
                ...initialDefaultState,
            }
        case ORDER_DETAIL_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case ORDER_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                status: true,
                data: action.payload
            }
        case ORDER_DETAIL_FAIL:
            return {
                ...state,
                loading: false,
                status: false,
                error: action.payload
            }
        default:
            return state;
    }
};

export const GetItemsReducer = (state = initialDefaultState, action: any) => {
    switch (action.type) {
        case GET_ITEMS_RESET:
            return {
                ...initialDefaultState,
            }
        case GET_ITEMS_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case GET_ITEMS_SUCCESS:
            return {
                ...state,
                loading: false,
                status: true,
                data: action.payload
            }
        case GET_ITEMS_FAIL:
            return {
                ...state,
                loading: false,
                status: false,
                error: action.payload
            }
        default:
            return state;
    }
};